import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import SAlert from "components/Alert"
import useSearch from "hooks/useSearch"
import ProvinceOutListComponent from "components/ProvinceOut/list"
import {
  deleteManyProvinceOut,
  deleteProvinceOut,
  exportProvinceOut,
  getProvinceOutProvinces,
  getProvinceOuts,
} from "store/province-out/province-out-action"
import {
  getProvinceIps,
  getProvinceItemCategories,
  getProvinceProjects,
  getProvinceProvinces,
  getProvinceCurrencies,
} from "store/province-dashboard/province-dashboard-action"
import ProvinceOutDetailModal from "components/ProvinceOut/Details"
import { getProvinceInProjects } from "store/province-in/province-in-action"

const ProvinceOutList = () => {
  // Meta Title
  document.title = "Distributions"

  const dispatch = useDispatch()
  const { data, error, loading, exportStatus } = useSelector(state => ({
    data: state.provinceOut.data,
    error: state.provinceOut.error,
    loading: state.provinceOut.loading,
    exportStatus: state.provinceOut.exportStatus,
  }))
  const permissions = useSelector(state => state.auth.permissions)
  const [deleteModal, setDeleteModal] = useState(false)
  const [proOut, setProOut] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  // Handle record deletion and close the delete modal
  // Dispatch delete action for the selected record
  // Close the delete modal
  const handleDeleteFunc = data => {
    if (proOut) {
      dispatch(deleteProvinceOut(proOut.id))
    }
    setDeleteModal(false)
  }

  // Handle multiple delete action when top delete button is clicked
  const onAllDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(deleteManyProvinceOut(ids))
    } else {
      SAlert({ text: "no distribution selected", status: "info" })
    }
  }

  // Set the record to be deleted and open the delete modal
  // Store the selected record for deletion
  // Open the delete confirmation modal
  const onClickDelete = data => {
    setProOut(data)
    setDeleteModal(true)
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProvinceOuts(link.url, pageNumber, according, search, advnacedSearch)
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getProvinceOuts(undefined, undefined, undefined, search, advnacedSearch),
    search
  )

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getProvinceOuts(undefined, pageNumber, according, search, advnacedSearch)
    )
  }, [pageNumber, according])

  // fetch other data for filter
  useEffect(() => {
    dispatch(getProvinceItemCategories())
    dispatch(getProvinceOutProvinces())
    dispatch(getProvinceIps())
    dispatch(getProvinceInProjects())
    dispatch(getProvinceCurrencies())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(getProvinceOuts(undefined, undefined, undefined, search, data))
  }

  // Show record details in a modal when the detail button is clicked
  const onClickDetail = data => {
    setProOut(data)
    setDetailModal(true)
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportProvinceOut(advnacedSearch))
  }

  return (
    <React.Fragment>
      {/* Delete Modal / */}
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      {/* Detail Modal  */}
      <ProvinceOutDetailModal
        data={proOut}
        open={detailModal}
        setOpen={setDetailModal}
      />
      <Breadcrumbs title={"Province"} breadcrumbItem={"Distributions"} />
      {/* Province Out (Distributino) Component / */}
      <ProvinceOutListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAllDeleteClicked={onAllDeleteClicked}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        permissions={permissions}
        onClickDetail={onClickDetail}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default ProvinceOutList
